export default {"src":"/_next/static/media/light-dark.e6dfb15c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};